import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d7d92a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-step step-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " Step 1 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createTextVNode(" 투명 음료 페트병 분류: "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 올바르게 분리배출된 투명 음료 페트병 선별 ")
], -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "box-step step-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " Step 2 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createTextVNode(" 세척 및 분쇄: "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 투명 음료 페트병을 세척한 후 플레이크(Flake)로 파쇄 ")
], -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "box-step step-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " Step 3 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createTextVNode(" 재가공: "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 플레이크(Flake)는 다시 동글동글한 칩(Chip)으로 재탄생 ")
], -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "box-step step-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " Step 4 ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createTextVNode(" r-PET 프리폼 생산: "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 칩(Chip)을 녹여 프리폼 제작 ")
], -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "box-step step-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " Step 5 ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createTextVNode(" 코카-콜라 재생 보틀 완성: "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 성형을 통해 r-PET 프리폼이 코카-콜라 재생 보틀로 변신 ")
], -1))
const _hoisted_20 = ["src"]

import Popup from './popup.vue';
import { type ComputedRef, inject } from 'vue';

interface Props {
  modelValue: boolean;
}

interface Emits {
  (event: 'update:model-value', val: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', val: boolean): void;
}), expose: any, slots: any, attrs: any }) {




const images = inject<ComputedRef<Record<string, string>>>('images')!;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": __props.modelValue,
    title: "재생 보틀 제작 과정",
    class: "popup-recycled-bottle-production-process",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emits('update:model-value', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("img", {
          src: _unref(images)['recycled-bottle-production-process-step-1']
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("img", {
          src: _unref(images)['recycled-bottle-production-process-step-2']
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("img", {
          src: _unref(images)['recycled-bottle-production-process-step-3']
        }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _hoisted_15,
        _createElementVNode("img", {
          src: _unref(images)['recycled-bottle-production-process-step-4']
        }, null, 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _createElementVNode("img", {
          src: _unref(images)['recycled-bottle-production-process-step-5']
        }, null, 8, _hoisted_20)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})